import { Component, inject, input, signal } from '@angular/core';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'c-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css',
  standalone: false,
})
export class SpinnerComponent {
  private readonly spinner = inject(SpinnerService);
  showSpinner = input<boolean>(false);
  show = signal<boolean>(false);
  ngAfterViewInit() {
    this.show.set(this.showSpinner());
    /** @description Nos suscribimos para obtener el estado del spinner */
    this.spinner.isLoading.subscribe((isLoading) => {
      setTimeout(() => {
        this.show.set(isLoading);
      });
    });
  }
}
